import React, { useState } from 'react';
import { motion } from 'framer-motion';

// Images (place these in src/images/photos/)
import heroGif from '../images/photos/zero-touch.gif';
import zteIllustration from '../images/photos/zte-illustration.png';
import gallery1 from '../images/photos/gallery 11.jpg';
import gallery2 from '../images/photos/gallery 22.jpg';

const pageVariants = {
  initial: { rotateY: 90, opacity: 0 },
  in: { rotateY: 0, opacity: 1 },
  out: { rotateY: -90, opacity: 0 }
};

const pageTransition = {
  type: 'spring',
  stiffness: 80,
  damping: 20
};

export default function Services_AndroidZeroTouchEnrollment() {
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxSrc, setLightboxSrc] = useState(heroGif);

  const features = [
    'Automated Device Enrollment',
    'Bulk Provisioning',
    'Security & Compliance',
    'Seamless MDM Integration',
    'Pre-configured Wi-Fi',
    'Scalability & Flexibility',
    'Cost Efficiency',
    'User-friendly Setup'
  ];

  const services = [
    'Android Zero Touch Enrollment',
    'Android Management',
    'Cloud Computing',
    'Cloud Management Service',
    'Cyber Security',
    'iOS Management',
    'Mobile Management',
    'IT Management',
    'IT Support',
    'Software Development',
    'Digital Marketing'
  ];

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageVariants}
      transition={pageTransition}
      style={{
        minHeight: '60vh',
        padding: 24,
        fontFamily: "Inter, system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial",
        color: '#0f172a',
        background: '#f8fafc'
      }}
    >
      {/* ===== HERO (INSERTED CONTENT) ===== */}
      <section style={{ maxWidth: 1100, margin: '0 auto 28px', display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <div style={{ flex: 1, minWidth: 280 }}>
          <p style={{ color: '#4f46e5', fontWeight: 700, letterSpacing: 1 }}>Services</p>
          <h1 style={{ marginTop: 8, fontSize: 28 }}>Android Zero Touch Enrollment</h1>
          <p style={{ marginTop: 12, color: '#475569', lineHeight: 1.5 }}>
            Both rest of know draw fond post as. It agreement defective to excellent. Feebly do engage of narrow.
            Extensive repulsive belonging depending if promotion be zealously as. Preference inquietude ask now are dispatched led appearance.
            Small meant in so doubt hopes. Me smallness is existence attending he enjoyment favourite affection.
            Delivered is to ye belonging enjoyment preferred. Astonished and acceptance men two discretion.
          </p>

          <div style={{ marginTop: 14, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
            <a href="mailto:support@zyntro.in" style={{ background: '#4f46e5', color: 'white', padding: '10px 14px', borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}>
              Contact Support
            </a>
            <a href="tel:+919956353236" style={{ border: '1px solid #4f46e5', color: '#4f46e5', padding: '10px 14px', borderRadius: 8, textDecoration: 'none', fontWeight: 600 }}>
              Call +91-9956353236
            </a>
          </div>

          <div style={{ marginTop: 16, background: 'white', padding: 14, borderRadius: 10, boxShadow: '0 6px 20px rgba(2,6,23,0.06)' }}>
            <h3 style={{ margin: 0 }}>Quick overview</h3>
            <p style={{ marginTop: 8, color: '#475569', fontSize: 14 }}>
              Android Zero Touch Enrollment is a deployment solution provided by Google that allows businesses to automatically configure Android devices when they are first powered on. Devices arrive enterprise-ready with pre-configured apps, policies and network settings.
            </p>
          </div>
        </div>

        <div style={{ flex: 1, minWidth: 280, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <button
            onClick={() => { setLightboxSrc(heroGif); setLightboxOpen(true); }}
            aria-label="Open hero GIF"
            style={{ border: 'none', background: 'transparent', padding: 0, cursor: 'pointer', borderRadius: 12, overflow: 'hidden', boxShadow: '0 10px 30px rgba(2,6,23,0.08)' }}
          >
            <img src={heroGif} alt="Android Zero Touch Enrollment demo GIF" style={{ display: 'block', width: '100%', maxWidth: 440 }} loading="lazy" />
          </button>
        </div>
      </section>

      {/* ===== HOW IT WORKS & FEATURES ===== */}
      <section style={{ maxWidth: 1100, margin: '0 auto 28px', display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
        <article style={{ background: 'white', padding: 20, borderRadius: 10, boxShadow: '0 6px 20px rgba(2,6,23,0.04)' }}>
          <h2 style={{ marginTop: 0 }}>What is Android Zero Touch Enrollment?</h2>
          <p style={{ color: '#475569', lineHeight: 1.5 }}>
            Android Zero Touch Enrollment is a deployment solution provided by Google that allows businesses to automatically configure Android devices when they are first powered on. This means that there is no need for manual intervention, and devices can be set up in bulk quickly, without the need for IT teams to physically handle each individual device. The service works with Android devices that support Zero Touch Enrollment, and it integrates directly with Mobile Device Management (MDM) solutions.
          </p>

          <h3 style={{ marginTop: 14 }}>How does it work?</h3>
          <p style={{ color: '#475569', lineHeight: 1.5 }}>
            Devices are registered via the Zero Touch portal by the reseller/carrier and linked to your MDM. When a user powers the device and connects to the internet, the device automatically contacts the MDM and downloads policies, apps, and network settings — no manual setup required.
          </p>

          <h3 style={{ marginTop: 14 }}>Key features</h3>
          <ul style={{ marginTop: 10, paddingLeft: 18, display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 10 }}>
            {features.map((f) => (
              <li key={f} style={{ background: '#f8fafc', padding: 10, borderRadius: 8, display: 'flex', gap: 10, alignItems: 'center' }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#4f46e5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                <div>
                  <div style={{ fontWeight: 600 }}>{f}</div>
                  <div style={{ fontSize: 12, color: '#64748b' }}>{f === 'Pre-configured Wi-Fi' ? 'Wi-Fi credentials can be pushed so users connect automatically.' : ''}</div>
                </div>
              </li>
            ))}
          </ul>
        </article>

        <aside style={{ background: 'white', padding: 16, borderRadius: 10, boxShadow: '0 6px 20px rgba(2,6,23,0.04)' }}>
          <img src={zteIllustration} alt="ZTE Illustration" style={{ width: '100%', height: 140, objectFit: 'contain' }} />
          <div style={{ marginTop: 12 }}>
            <h4 style={{ margin: 0 }}>Scalable enterprise deployments</h4>
            <p style={{ marginTop: 8, color: '#475569', fontSize: 14 }}>Deploy 10 or 10,000 devices with policies, apps and management applied automatically.</p>
          </div>

          <div style={{ marginTop: 16, borderTop: '1px solid #e6edf3', paddingTop: 12 }}>
            <h5 style={{ margin: 0 }}>Contact</h5>
            <p style={{ margin: '8px 0 0', fontSize: 14, color: '#475569' }}>+91-9956353236</p>
            <p style={{ margin: '4px 0 0', fontSize: 14, color: '#475569' }}>support@zyntro.in</p>
            <p style={{ margin: '4px 0 0', fontSize: 14, color: '#475569' }}>Sant Ravidas Nagar, Bhadohi, Uttar Pradesh</p>
          </div>
        </aside>
      </section>

      {/* ===== SERVICES + GALLERY ===== */}
      <section style={{ maxWidth: 1100, margin: '0 auto 28px', display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
        <div style={{ background: 'white', padding: 20, borderRadius: 10, boxShadow: '0 6px 20px rgba(2,6,23,0.04)' }}>
          <h3 style={{ marginTop: 0 }}>Our Services</h3>
          <p style={{ color: '#475569' }}>We provide full lifecycle support for device management and enterprise mobility.</p>
          <ul style={{ marginTop: 12, display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: 8 }}>
            {services.map((s) => (
              <li key={s} style={{ background: '#fbfdff', padding: 10, borderRadius: 8, display: 'flex', gap: 10, alignItems: 'center' }}>
                <div style={{ width: 36, height: 36, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#eef2ff', color: '#4f46e5', fontWeight: 700 }}>{s.charAt(0)}</div>
                <div style={{ fontSize: 14 }}>{s}</div>
              </li>
            ))}
          </ul>
        </div>

        <aside style={{ background: 'white', padding: 16, borderRadius: 10, boxShadow: '0 6px 20px rgba(2,6,23,0.04)' }}>
          <h4 style={{ marginTop: 0 }}>Gallery</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
            {[gallery1, gallery2, heroGif].map((src, i) => (
              <button
                key={i}
                onClick={() => { setLightboxSrc(src); setLightboxOpen(true); }}
                style={{ border: 'none', padding: 0, cursor: 'pointer', borderRadius: 8, overflow: 'hidden' }}
              >
                <img src={src} alt={`gallery-${i}`} style={{ width: '100%', height: 80, objectFit: 'cover', display: 'block' }} />
              </button>
            ))}
          </div>
        </aside>
      </section>

      {/* ===== FOOTER CTA ===== */}
      <section style={{ maxWidth: 1100, margin: '0 auto 28px', background: 'linear-gradient(90deg,#6366f1,#4f46e5)', padding: 18, borderRadius: 10, color: 'white', boxShadow: '0 10px 30px rgba(79,70,229,0.15)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
          <div>
            <h4 style={{ margin: 0 }}>Ready to simplify device deployment?</h4>
            <p style={{ marginTop: 6, opacity: 0.95 }}>Reach out and we'll help you set up Zero Touch Enrollment at scale.</p>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <a href="mailto:support@zyntro.in" style={{ background: 'white', color: '#4f46e5', padding: '8px 12px', borderRadius: 8, textDecoration: 'none', fontWeight: 700 }}>
              Email Us
            </a>
            <a href="tel:+919956353236" style={{ border: '1px solid white', color: 'white', padding: '8px 12px', borderRadius: 8, textDecoration: 'none' }}>
              Call
            </a>
          </div>
        </div>
      </section>

      {/* ===== ORIGINAL ANIMATED BLOCK (kept as-is, now after content) ===== */}


      {/* ===== LIGHTBOX ===== */}
      {lightboxOpen && (
        <div
          role="dialog"
          aria-modal="true"
          onClick={() => setLightboxOpen(false)}
          style={{ position: 'fixed', inset: 0, zIndex: 60, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}
        >
          <div onClick={(e) => e.stopPropagation()} style={{ maxWidth: 980, width: '100%', background: 'white', borderRadius: 10, overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 8 }}>
              <button onClick={() => setLightboxOpen(false)} style={{ border: 'none', background: 'transparent', cursor: 'pointer', padding: 8 }}>Close</button>
            </div>
            <img src={lightboxSrc} alt="preview" style={{ width: '100%', height: 'auto', display: 'block' }} />
          </div>
        </div>
      )}
    </motion.div>
  );
}
